import client from '../../client';
import { logoutAction } from '../auth/action';

export default {
  setupInterceptors: (store, history) => {
    client.interceptors.response.use(
      response => {
        return response;
    }, error => {
        if ( error.response.status === 401) {
          store.dispatch(logoutAction());
          history.push('/login');
        }
        return Promise.reject(error);
    });
  }
};


// WEBPACK FOOTER //
// ./src/store/services/networkService.js